
@if (bannerNode | async; as item) {
  @if (item.uid === 'comp1-returnsLandingPage') {
    <div>
      @if (isVisible) {
        <div>
          @if (showloader) {
            <div class="loading" >
              <div class="loading_txt">
                <div class="load_txt">{{"returnsUK.loadinglabel" | cxTranslate}}</div>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          }
          @if (showloader_download) {
            <div class="loading" >
              <div class="loading_txt">
                <div class="load_txt">{{"returnsUK.downloadinglabel" | cxTranslate}}</div>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          }
          <div id="forUKReturns">
            <section class="col-xs-12 col-sm-12 returnsLanding_body">
              <div class="col-xs-12 col-sm-12">
                <div class="col-xs-12 col-sm-12 col-md-12 no-padding returnsRed_header margin-B30">{{item.paragraphcontent}}</div>
                @if (shownoreturns) {
                  <div>
                    @if (!returnEligilibity) {
                      <div class="col-xs-12 col-sm-12 col-md-12 no-padding noreturn_subheader margin-B30">{{"returnsUK.returnsclosemsg" | cxTranslate}}</div>
                    }
                  </div>
                }
                @if (returnEligilibity) {
                  <div class="returns_topTextContainer">
                    <div class="col-xs-12 col-sm-6 col-md-6 no-left-pad" >
                      <div class="col-xs-12 col-sm-12 col-md-12 no-padding return_subheader">{{item.h2content}}</div>
                      <div class="col-xs-12 col-sm-12 col-md-12 no-padding return_headerpara" [innerHTML]="item.content" appRouterlinkinterceptor>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 topBtnContainer">
                      @if (returnrba?.RBAPermissions==true) {
                        @if (returnrba?.showDashboardOrderUK==true) {
                          <div class="flexDiv">
                            <button id="NewReturn_btn" (click)="showNewReturn()">
                            {{"returnsUK.startreturn" | cxTranslate}}</button>
                            <div class="returns_topText1">Or</div>
                            <div class="noReturnBtnParent">
                              <button id="verifyNoReturnBtn" (click)="showNoreturn()">{{"returnsUK.verifynoreturn" | cxTranslate}}</button>
                            </div>
                          </div>
                        }
                      } @else {
                        <div class="flexDiv">
                          <button id="NewReturn_btn" (click)="showNewReturn()">
                          {{"returnsUK.startreturn" | cxTranslate}}</button>
                          <div class="returns_topText1">Or</div>
                          <div class="noReturnBtnParent">
                            <button id="verifyNoReturnBtn" (click)="showNoreturn()">{{"returnsUK.verifynoreturn" | cxTranslate}}</button>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="clearboth"></div>
              <br/>
              <div class="col-xs-12 col-sm-12 financial_returnProcess">
                <div class="clearboth"></div>
                <div class="return_subheader">{{item.text1}}</div>
                <div class="return_subtxt">{{item.LargeText1}}</div>
                <div class="col-xs-12 col-sm-12 financial_returnSliderparent">
                  <div class="financial_returnSlider">
                    <div class="financial_circlededge"></div>
                    <div class="financial_middleline">
                      <div class="financial_circle1">
                        <div class="financial_outer-circle">
                          <div class="financial_inner-circle"></div>
                        </div>
                      </div>
                      <div class="financial_circle2">
                        <div class="financial_outer-circle">
                          <div class="financial_inner-circle"></div>
                        </div>
                      </div>
                      <div class="financial_circle3">
                        <div class="financial_outer-circle">
                          <div class="financial_inner-circle"></div>
                        </div>
                      </div>
                    </div>
                    <div class="financial_circlededge"></div>
                  </div>
                  <div class="financial_textcontent">
                    <div class="financial_text1">
                      <p>{{item.text2}}</p>
                      <span>{{item.LargeText2}}</span>
                    </div>
                    <div class="financial_text2" >
                      <p>{{item.text3}}</p>
                      <span>{{item.LargeText3}}</span>
                    </div>
                    <div class="financial_text3" >
                      <p>Credit Applied</p>
                      <span>{{item.text4}}</span>
                    </div>
                    <div class="clearboth"></div>
                  </div>
                </div>
              </div>
              <div class="clearboth"></div>
              <div class="returnsBody_textSection">
                <div class="col-xs-12 col-sm-12">
                  <div class="col-xs-12 col-sm-12 no-padding returnsRed_header">{{"returnsUK.myreturns" | cxTranslate}}</div>
                  <div class="col-xs-12 col-sm-12 no-padding returns_subheaderParent">
                    <div class="col-xs-12 col-sm-6 no-padding returnsBody_subheader">{{"returnsUK.returnsmsg" | cxTranslate}}</div>
                    <div class="col-xs-12 col-sm-6 returnSeason"><div>{{"returnsUK.returnseason" | cxTranslate}}&nbsp;</div>
                    <select class="Return_current_sesson_dropdown" name="session" id="Return_select_season" (change)="onSeasonChange($event)">
                      @for (season of seasons; track season) {
                        <option [value]="season" [selected]="season === defaultReturnSeason">
                          {{"returnsUK.selectseasontxt" | cxTranslate}}{{ season }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
            @if (noReturnsAvailable) {
              <div  class="col-xs-12 col-md-12 noMyReturnText">
                {{"returnsUK.noreturnssubmitmsg" | cxTranslate}}
              </div>
            }
            @if (returnsAvailble) {
              <section class="col-xs-12 col-md-12 returns_midsection">
                <!-- Table starts -->
                <div class="col-xs-12 col-md-5 no-left-pad returnstablecontainer">
                  <div class="form-group returns_datasearch">
                    <div class="col-xs-10 col-md-10 searchbox">
                      <div class="input-group returns_order">
                        <div class="input-group-addon">
                          <i class="fa fa-search"></i>
                        </div>
                        <input class="form-control" id="returns_search" name="lookup" type="text" matInput (keyup)="applyFilter($event)"   #searchInput>
                      </div>
                    </div>
                    <div class="col-xs-1 col-md-1 filterbox" (click)="toggleFilter($event)">
                      <img alt="Filter" src="assets/images/filter.png" width="25">
                      @if (selectedFilterCount > 0) {
                        <span>{{selectedFilterCount}}</span>
                      }
                      <div class="filterText">Filter</div>
                    </div>
                    <div class="col-xs-1 col-md-1 sortbox" (click)="toggleSort($event)">
                      <img src="assets/images/sort.png" width="25" alt="sort">
                      <div class="filterText">Sort</div>
                    </div>
                  </div>
                  @if (showFilterSort) {
                    <div class="sortopen show" (click)="onDivClick($event)">
                      <div class="locationsection">
                        <div class="filterheader">{{"returnsUK.loctxt" | cxTranslate}}</div>
                        <div class="returns_radioparent">
                          <label class="radio-button">
                            <input type="radio" class="invoice_radio" name="radiobtn" [(ngModel)]="selectedSortOrder" value="asc" (change)="sortData('asc')">
                            <span class="radio-button__control"></span>
                          </label>
                          <label>{{"returnsUK.atozlabel" | cxTranslate}}</label>
                        </div>
                        <div class="returns_radioparent">
                          <label class="radio-button">
                            <input type="radio" class="invoice_radio" name="radiobtn" [(ngModel)]="selectedSortOrder" value="dsc" (change)="sortData('desc')">
                            <span class="radio-button__control"></span>
                          </label>
                          <label>{{"returnsUK.ztoalabel" | cxTranslate}}</label>
                        </div>
                      </div>
                      <div class="clearboth"></div>
                      <div class="returns_reset" id="returns_resetsort" (click)="resetSort()">{{"returnsUK.resetlabel" | cxTranslate}}</div>
                      <div class="clearboth"></div>
                    </div>
                  }
                  @if (showFilterPanel) {
                    <div class="filteropen show" (click)="onDivClick($event)">
                      <div class="prodsection">
                        <div class="filterheader">{{"returnsUK.byproduct" | cxTranslate}}</div>
                        <div class="returns_checkboxparent">
                          <label class="checkbox-button">
                            <input type="checkbox" name="prodname"  class="returns_checkbox" [(ngModel)]="selectedProducts.aqiv" (change)="applyFilters()">
                            <span class="checkbox-button__control"></span>
                          </label>
                          <label>{{ (isDefaultSeason() ? "returnsUK.ativ10pack" : "returnsUK.aqiv10pack") | cxTranslate }}</label>
                        </div>
                        <div class="returns_checkboxparent">
                          <label class="checkbox-button">
                            <input type="checkbox" name="prodname"  class="returns_checkbox" [(ngModel)]="selectedProducts.qivc" (change)="applyFilters()">
                            <span class="checkbox-button__control"></span>
                          </label>
                          <label>{{ (isDefaultSeason() ? "returnsUK.tivc10pack" : "returnsUK.qivc10pack") | cxTranslate }}</label>
                        </div>
                      </div>
                      <div class="statussection">
                        <div class="filterheader">{{"returnsUK.bystatus" | cxTranslate}}</div>
                        <div class="returns_checkboxparent">
                          <label class="checkbox-button">
                            <input type="checkbox" name="status" value="APPROVED" class="returns_checkbox" [(ngModel)]="selectedStatus.approved" (change)="applyFilters()">
                            <span class="checkbox-button__control"></span>
                          </label>
                          <label>{{"returnsUK.approvedlabel" | cxTranslate}}</label>
                        </div>
                        <div class="returns_checkboxparent">
                          <label class="checkbox-button">
                            <input type="checkbox" name="status" value="SUBMITTED" class="returns_checkbox" [(ngModel)]="selectedStatus.submitted" (change)="applyFilters()">
                            <span class="checkbox-button__control"></span>
                          </label>
                          <label>{{"returnsUK.submittedlabel" | cxTranslate}}</label>
                        </div>
                        <div class="returns_checkboxparent">
                          <label class="checkbox-button">
                            <input type="checkbox" name="status" value="NO RETURNS" class="returns_checkbox" [(ngModel)]="selectedStatus.noReturns" (change)="applyFilters()">
                            <span class="checkbox-button__control"></span>
                          </label>
                          <label>{{"returnsUK.noreturnslabel" | cxTranslate}}</label>
                        </div>
                      </div>
                      <div class="returns_reset" id="returns_resetfilter" (click)="resetFilters()">{{"returnsUK.resetlabel" | cxTranslate}}</div>
                      <div class="clearboth"></div>
                    </div>
                  }
                  <hr>
                    <table mat-table [dataSource]="dataSource" class="dataTable no-footer" id="returnfilterTable">
                      <!-- Combined Column -->
                      <ng-container matColumnDef="combined">
                        <th  *matHeaderCellDef class="no-thead"></th>
                        <td mat-cell *matCellDef="let element" class="return_table_td" >
                          <div class="returns_firstrow">
                            <div class="return_season">{{element.orderSeason}} SEASON</div>
            <div class="returns_status" [ngClass]="{
              'submitted': element.status === 'SUBMITTED',
              'notReturns': element.status === 'NO RETURNS',
              'approved': element.status === 'APPROVED'
            }">{{element.status}}</div>
                          </div>
                          <div class="returnOrg_name">{{element.companyName}}</div>
                          @if (element.aqivDoseReturned !== 0) {
                            <div class="returns_unit"><span>{{ (isDefaultSeason() ? 'aTIV Doses Remaining:' : 'aQIV Dose Returned:')  }}</span><span class="doseValue">{{element.aqivDoseReturned}}</span></div>
                          }
                          @if (element.qivcDoseReturned !== 0) {
                            <div class="returns_unit"><span>{{ (isDefaultSeason() ? 'TIVc Doses Remaining:' : 'QIVc Dose Returned:') }}</span><span class="doseValue">{{element.qivcDoseReturned}}</span></div>
                          }
                          <div class="returns_location"><span>{{"returnsUK.delivloc" | cxTranslate}}</span><span class="elements_Loc">{{element.loc}}</span></div>
                          <!-- <div class="searchorder locID">{{element.locID}}</div> -->
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.active]="row === selectedRow" (click)="onRowClicked(row)"></tr>
                    </table>
                    @if (dataSource.filteredData.length === 0) {
                      <div class="dataTables_empty">{{"returnsUK.norecordsmsg" | cxTranslate}}</div>
                    }
                    <mat-paginator [length]="dataSource.data.length" [pageSize]="5" [pageSizeOptions]="[1]" showFirstLastButtons ></mat-paginator>
                    <div class="dataTables_paginate paging_full_numbers" id="returnfilterTable_paginate">
                      <a class="paginate_button first"  [class.disabled]="currentPage === 1"><img alt="Navigate" (click)="goToFirstPage()" to="" previous="" page="" src="assets/images/pagination-double-prev-arrow-icon.svg"></a>
                      <a class="paginate_button previous disabled" [class.disabled]="currentPage === 1"><img alt="Navigate" (click)="goToPreviousPage()" to="" previous="" page="" src="assets/images/pagination-prev-btn.svg"></a>
                      @if (dataSource.filteredData.length > 0) {
                        @for (page of pages; track page) {
                          <span (click)="goToPage(page)" [class.active]="page === currentPage"><a class="paginate_button current">{{page}}</a></span>
                        }
                      }
                      <a class="paginate_button next" [class.disabled]="currentPage === totalPages"><img alt="Navigate" (click)="goToNextPage()" to="" next="" page="" src="assets/images/pagination-next-btn.svg"></a>
                      <a class="paginate_button last" [class.disabled]="currentPage === totalPages"><img alt="Navigate" (click)="goToLastPage()" to="" last="" page="" src="assets/images/pagination-double-next-arrow-icon.svg"></a>
                    </div>
                  </div>
                  <!-- Table Ends -->
                  <!-- right side -->
                  @if (returnsAvailble && (dataSource?.data?.length ?? 0) > 0) {
                    <div class="col-xs-12 col-md-7 returns_details active" >
                      @if (selectedDetails) {
                        <div>
                          <div class="row returns_details_row">
                            <div class="col-md-7 col-xs-12">
                              <div class="col-md-12 col-xs-12 returns_rightOrgName">{{selectedDetails.companyName}}</div>
                              <div class="col-md-12 col-xs-12 no-left-pad">
                                <div class="col-md-3 col-xs-12 no-left-pad">
                                  <div class="col-md-12 col-xs-12 returns_details_header">{{"returnsUK.sor" | cxTranslate}}</div>
                                  <div class="col-md-12 col-xs-12 returns_details_subheader">{{selectedDetails.sor}}%</div>
                                </div>
                                <div class="col-md-9 col-xs-12">
                                  <div class="col-md-12 col-xs-12 returns_details_header">{{"returnsUK.delivaddr" | cxTranslate}}</div>
                                  <div class="col-md-12 col-xs-12 returns_details_subheader addess">{{selectedDetails.loc}}</div>
                                </div>
                              </div>
                            </div>
                            @if (selectedDetails.checkForAddRetEligible == true && selectedDetails.addReturnPresent == false && returnEligilibity==true && selectedDetails.rbaPermission=='MANAGE') {
                              <div class="col-md-5 col-xs-12 no-pad returnMore_greybtncontainer">
                                <div class="return_greybtn addReturnBtn" id="additionalReturn" (click)="showAdditionalReturn()">{{"returnsUK.returnmore" | cxTranslate}}</div>
                              </div>
                            }
                            @if (selectedDetails.checkForAddRetEligible == false || selectedDetails.addReturnPresent == true|| returnEligilibity==false || selectedDetails.rbaPermission!='MANAGE') {
                              <div class="col-md-5 col-xs-12 no-pad help_txt_return">
                                <div class="helpParent" [innerHTML]="'returnsUK.needhelptxt' | cxTranslate">
                                </div>
                              </div>
                            }
                          </div>
                          @for (location of selectedDetails.locations; track location; let i = $index) {
                            <div class="returnDoseBody active">
                              <div class="row returns_details_row col-md-12 col-xs-12 top_border">
                                @if (location.status !== 'No Returns' && location?.returnId) {
                                  <div class="col-xs-3 no-right-pad no-left-pad" [ngClass]="{'col-md-3': location.returnId, 'col-md-4': !location.returnId}">
                                    <div class="returns_details_header" >{{"returnsUK.returnrefno" | cxTranslate}}</div>
                                    <div class="returns_details_subheader returnNumber">{{location.returnId}}</div>
                                  </div>
                                }
                                <div class="col-md-3 col-xs-3 Returnstatwid no-right-pad" [ngClass]="{'Returnstatwid': location.returnId, 'col-md-4': !location.returnId}">
                                  <div class="returns_details_header">{{"returnsUK.returnstatus" | cxTranslate}}</div>
                                  <div class="returns_details_subheader rightStatusText">{{location.status}}</div>
                                </div>
                                <div class="col-md-3 col-xs-3 no-left-pad Returnsubmitwid no-right-pad" [ngClass]="{'Returnsubmitwid': location.returnId, 'col-md-4': !location.returnId}">
                                  <div class="returns_details_header">{{"returnsUK.returnsubmitton" | cxTranslate}}</div>
                                  <div class="returns_details_subheader">{{location.returnSubmittedOn}}</div>
                                </div>
                                @if (location.status !== 'No Returns') {
                                  <div class="col-md-3 col-xs-3 Returncredwid no-right-pad credit-issues-cell"  [ngClass]="{'Returncredwid': location.returnId, 'col-md-4': !location.returnId}">
                                    <div class="returns_details_header">{{"returnsUK.creditissueon" | cxTranslate}}</div>
                                    @if (location.creditIssued == false) {
                                      <div class="returns_details_subheader">{{"returnsUK.creditnotissue" | cxTranslate}}</div>
                                    }
                                    @if (location.creditIssued == true) {
                                      <div class="returns_details_subheader">
                                        {{location.creditIssuedDate}}<br/>
                                        @if (location.creditNumber != null) {
                                          <a (click)="financialgetDownloadInvoiceData(location.creditNumber)"  class="returnPopupshow">
                                            <span>{{"returnsUK.viewcredit" | cxTranslate}}</span>
                                            <div class="global_blackarrow"></div>
                                          </a>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                              @if (location.creditIssued == true && !location?.dosesDestroyed) {
                                <div class="row returns_details_row col-md-12 col-xs-12">
                                  @if (credit_dest_box[i]) {
                                    <div class="lightGreyBox">
                                      <div class="col-md-12 col-xs-12 checkBoxHeader">{{"returnsUK.creditissuemsg" | cxTranslate}}</div>
                                      <div class="destroy_checkboxparent col-md-12 col-xs-12">
                                        <label class="checkbox-button">
                                          <input type="checkbox" name="destroy_checkbox" id="destroy_checkbox[i]" [(ngModel)]="eachCheckboxChecked[i]" (change)="onCheckboxChange($event,location.returnId,i)" class="destroy_checkbox">
                                          <span class="checkbox-button__control"></span>
                                        </label>
                                        <label class="checkboxtext">{{"returnsUK.destroyconfrmmsg" | cxTranslate}}</label>
                                      </div>
                                    </div>
                                  }
                                  @if (confirm_destroy_msg[i]) {
                                    <div class="col-md-12 col-xs-12 confirmText">{{"returnsUK.destroythankyou" | cxTranslate}}</div>
                                  }
                                </div>
                              }
                              <div class="row returns_details_row tableParent col-md-12 col-xs-12">
                                @if (hasProducts(location,['aTIV','aQIV'])) {
                                  <div class=" col-xs-6 returns_tableConatiner" [ngClass]="isDefaultSeason()?'col-md-12':'col-md-7' ">
                                    <div class="col-md-12 col-xs-12 return_prodName">{{ (isDefaultSeason() ? "returnsUK.ativlabel" : "returnsUK.aqivlabel") | cxTranslate }}</div>
                                    <div class="col-md-12 col-xs-12 returns_details_header">{{"returnsUK.65yeartxt" | cxTranslate}}</div>
                                    <div class="clearboth"></div>
                                    <table class="table returns-details-table">
                                      <thead>
                                        <tr>
                                          <th>@if (location.returnId) {
                                            {{"returnsUK.batchnolabel" | cxTranslate}}
                                          }</th>
                                          <th>{{isDefaultSeason() ? "Doses Remaining" : "Returned Doses"}}</th>
                                          @if (location.returnId && isDefaultSeason()) {
                                            <th>{{"returnsUK.creditdoses" | cxTranslate}}</th>
                                          }
                                          @if (isDefaultSeason()) {
                                            <th>{{"returnsUK.sorallowancetxt" | cxTranslate}}</th>
                                          }
                                        </tr>
                                      </thead>
                                      @if (location.returnId) {
                                        <tbody>
                                          @for (product of filterProductsByType(location, ['aTIV','aQIV']); track product) {
                                            <tr >
                                              @if (product.selectedQuantity !== 0 || product.additionalQuantity !== 0) {
                                                <td>{{product.batchNumber}}</td>
                                              }
                                              @if (product.selectedQuantity !== 0 || product.additionalQuantity !== 0) {
                                                <td class="add">{{getDisplayedQuantity(product)}}</td>
                                              }
                                            </tr>
                                          }
                                        </tbody>
                                      }
                                    </table>
                                    <table class="totalShow">
                                      <tbody>
                                        <tr class="active">
                                          <th class="returns_total_row totalText">{{"returnsUK.totallabel" | cxTranslate}}</th>
                                          <th class="dose_counter">
                                            <span class="total_ord_qty returns_total_row">{{getTotalDoses(filterProductsByType(location, ['aTIV','aQIV']))}}</span>
                                          </th>
                                          @if (hasProducts(location,['aTIV','aQIV']) && location.returnId && isDefaultSeason()) {
                                            <th class="sor_Percentage">{{location.ativTotalDosesForCredit}}</th>
                                          }
                                          @if (isDefaultSeason()) {
                                            <th class="sor_Percentage">{{selectedDetails.sor}}%</th>
                                          }
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                }
                                @if (hasProducts(location, ['TIVc','QIVc'])) {
                                  <div class=" col-xs-6 returns_tableConatiner" [ngClass]="isDefaultSeason()?'col-md-12':'col-md-7' ">
                                    <div class="col-md-12 col-xs-12 return_prodName">{{ (isDefaultSeason() ? "returnsUK.tivclabel" : "returnsUK.qivclabel") | cxTranslate }}</div>
                                    <div class="col-md-12 col-xs-12 returns_details_header">{{"returnsUK.6monthtxt" | cxTranslate}}</div>
                                    <div class="clearboth"></div>
                                    <table class="table returns-details-table qivcTable">
                                      <thead>
                                        <tr>
                                          <th>@if (location.returnId) {
                                            {{"returnsUK.batchnolabel" | cxTranslate}}
                                          }</th>
                                          <th>{{isDefaultSeason() ? "Doses Remaining" : "Returned Doses"}}</th>
                                          @if (location.returnId && isDefaultSeason()) {
                                            <th>{{"returnsUK.creditdoses" | cxTranslate}}</th>
                                          }
                                          @if (isDefaultSeason()) {
                                            <th>{{"returnsUK.sorallowancetxt" | cxTranslate}}</th>
                                          }
                                        </tr>
                                      </thead>
                                      @if (location.returnId) {
                                        <tbody>
                                          @for (product of filterProductsByType(location, ['TIVc','QIVc']); track product) {
                                            <tr>
                                              @if (product.selectedQuantity !== 0 || product.additionalQuantity !== 0) {
                                                <td>{{product.batchNumber}}</td>
                                              }
                                              @if (product.selectedQuantity !== 0 || product.additionalQuantity !== 0) {
                                                <td class="add">{{getDisplayedQuantity(product)}}</td>
                                              }
                                            </tr>
                                          }
                                        </tbody>
                                      }
                                    </table>
                                    <table class="totalShow">
                                      <tbody>
                                        <tr class="active">
                                          <th class="returns_total_row totalText">{{"returnsUK.totallabel" | cxTranslate}}</th>
                                          <th class="dose_counter">
                                            <span class="total_ord_qty returns_total_row">{{getTotalDoses(filterProductsByType(location, ['TIVc','QIVc']))}}</span>
                                          </th>
                                          @if (hasProducts(location,['TIVc','QIVc']) && location.returnId && isDefaultSeason()) {
                                            <th class="sor_Percentage">{{location.tivcTotalDosesForCredit}}</th>
                                          }
                                          @if (isDefaultSeason()) {
                                            <th class="sor_Percentage">{{selectedDetails.sor}}%</th>
                                          }
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                }
                              </div>
                              <div class="clearboth"></div>
                              @if (location.imageUploads && location.imageUploads.length > 0) {
                                <div class="col-xs-12 returns_greybtncontainer no-left-pad">
                                  <div class="return_greybtn imgUploadBtn" id="viewUpload-RMA000002HI8" (click)="openImageDialog(location)">{{"returnsUK.viewimages" | cxTranslate}}</div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </section>
              }
            </section>
            @if (isCheckboxChecked) {
              <section >
                <div id="returns_destroyPopup" class="modal fade in" role="dialog">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-body">
                        <h4 class="modal-title OMexit_popHeader col-xs-9">{{"returnsUK.confirmdosedestruction" | cxTranslate}}</h4>
                        <div class="col-xs-3">
                          <span class="OMexit_popClose" data-dismiss="modal" (click)="onButtonClick()">x</span>
                        </div>
                        <p class="OMexit_popSubHeader col-xs-12">{{"returnsUK.destroytitle" | cxTranslate}}</p>
                        <div class="clearboth"></div>
                        <div class="OM_exitPopBtnParent">
                          <button class="OM_popBackBtn" data-dismiss="modal" (click)="onButtonClick()">{{"returnsUK.cancellabel" | cxTranslate}}</button>
                          <button class="OM_popExitBtn" (click)="callDeleteDosesConsent()">{{"returnsUK.confirmlabel" | cxTranslate}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            }
          </div>
        </div>
      }
    </div>
  }
}
